import { ECodeType } from '@app/swagger-types';

// TODO: Remove Partial type
export const sampleDataByType: Partial<Record<ECodeType, () => string>> = {
  [ECodeType.WEBSITE]: () =>
    [
      'Name,Website URL',
      'First,https://example1.com',
      'Second,https://example2.com',
      'Third,https://example3.com',
    ].join('\n'),

  [ECodeType.GS1]: () => getGS1SampleCSV(),
};

const getGS1SampleCSV = (): string => {
  const header = [
    'Name',
    'GTIN (EAN) Code',
    'Title',
    'Description',
    ...Array.from({ length: 10 }, (_, i) => [`Link ${i + 1} title`, `Link ${i + 1} URL`]).flat(),
  ].join(',');

  const rows = [
    [
      'First',
      '8752365895129',
      'Product name 1',
      'Product description',
      'Product information',
      'https://example1.com',
      'Allergens',
      'https://example2.com',
      'Recipes',
      'https://example3.com',
      'Our company',
      'https://example4.com',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ].join(','),
    [
      'Second',
      '568875644342',
      'Product name 2',
      'Product description',
      'Product information',
      'https://example1.com',
      'Allergens',
      'https://example2.com',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ].join(','),
    [
      'Third',
      '182837445343',
      'Product name 3',
      'Product description',
      'Product information',
      'https://example1.com',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
    ].join(','),
  ];

  return [header, ...rows].join('\n');
};
